// Move BIS below the ATC button
(() => {
  const form = document.querySelector('form[id^="product_form_"]');

  if (!form) {
    return;
  }

  function waitForElement(selector, target, callback) {
    const observer = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i += 1) {
        const element = target.querySelector(selector);

        if (element) {
          observer.disconnect();
          callback(element);
          break;
        }
      }
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  function moveBISBelowATC(bisButton) {
    const atcWrapper = form.querySelector('#product-add');

    if (!atcWrapper) {
      return;
    }

    const trigger = bisButton.querySelector('#SI_trigger');

    bisButton.style.margin = '1rem 0 0 0';

    if (trigger) {
      trigger.style.margin = '0';
    }

    atcWrapper.appendChild(bisButton);
  }

  waitForElement('#SI_trigger_wrapper', form, moveBISBelowATC);
})();
